import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String };

  connect() {
    // console.log('Sortable controller connected to:', this.element)
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      sort: true,
      handle: ".drag-handle",
      // draggable: ".nested-fields",
      filter: ".links, .alert",
      onEnd: this.end.bind(this)
    });
  }

  disconnect() {
    this.sortable.destroy();
  }

  end(event) {
    // console.log('Container ID:', this.element.id)
    // const sortableItems = this.element.querySelectorAll('.nested-fields')
    // console.log('Total sortable items:', sortableItems.length)
    // console.log('Sortable items:', Array.from(sortableItems).map(el => ({
    //   id: el.dataset.id,
    //   position: el.style.order
    // })))
    // console.log('Original index:', event.oldIndex)
    // console.log('New index:', event.newIndex + 1)

    let id = event.item.dataset.id;

    if (this.urlValue && this.urlValue.length > 0) {
      let url = this.urlValue.replace(":id", id);

      patch(url, {
        body: JSON.stringify({ position: event.newIndex + 1 })
      });
    }
  }
}
